// extracted by mini-css-extract-plugin
module.exports = {"transparent":"mvMyJD8a","color":"Q_8seuPA","secondaryColor":"wS7t6XcQ","hiddenColor":"X_Ns5_UN","hiddenBgColor":"_1P5sOHFd","bgColor":"s4h90JTd"};